<template>
  <v-row>
    <v-col
      cols="12"
      md=""
    >
      <div class="box">
        <h1>Documentos Complementares</h1>
        <v-row
          class="pt-3"
          :key="key"
        >
          <v-col
            class="py-0"
            cols="12"
            md="12"
          >
            <v-divider class="py-3" />
          </v-col>
          <template v-for="(document, i) in documents">
            <v-col
              class="py-0"
              cols="12"
              md="3"
              :key="'type' + i"
            >
              <v-autocomplete
                label="Tipo"
                :items="documentTypes"
                item-text="description"
                item-value="id"
                v-model="documents[i].operationalDocumentType"
                return-object
                clearable
                dense
                outlined
                v-disabled-icon-focus
                :disabled="!!(documents[i].document || documents[i].path)"
              />
            </v-col>
            <v-col
              class="py-0"
              cols="12"
              md="3"
              :key="'documents' + i"
            >
              <DocumentInput
                :description="false"
                v-model="documents[i]"
                :api="apiDocument"
                :customer-id="customer.id"
                :disabled="!documents[i].operationalDocumentType?.id"
              >
                <template #append-outer>
                  <v-btn 
                    v-if="documents.length >= 2 && !(documents[i].document || documents[i].path)"
                    class="py-0"
                    icon
                    @click="removeDocument(i)"
                    text
                  >
                    <i class="far fa-trash" />
                  </v-btn>
                  <v-btn
                    class="py-0"
                    icon
                    @click="insertDocument"
                    text
                  >
                    <i class="far fa-plus" />
                  </v-btn>
                </template>
              </DocumentInput>
            </v-col>
          </template>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
// Components
import DocumentInput from "@/components/comum/DocumentInput";

// APIs
import apiCustomerOperationalDocuments from "@/api/customer/customer-operational-documents-api";

// Constants
import { OPERATIONAL_DOCUMENT_TYPE } from "@/constants/general-constants.js";

// Models
import CustomerOperationalDocumentModel from "@/model/customer-operational-document-model";

export default {
  name: "CustomerOperationalDocuments",
  components: { DocumentInput },
  model: {
    prop: "customerProp",
    event: "onChange",
  },
  props: {
    customerProp: {
      type: Object,
    },
  },
  data() {
    return {
      customer: this.customerProp,
      apiDocument: apiCustomerOperationalDocuments,
      documentTypes: OPERATIONAL_DOCUMENT_TYPE,
      documents: [],
      key: 0,
    };
  },
  mounted() {
    this.documents = this.customer.operationalDocuments;

    if (this.documents.length == 0) {
      this.documents = [new CustomerOperationalDocumentModel()];
    }
  },
  watch: {
    "documents": {
      handler() {
        this.key = this.key + 1;
        this.updateCustomerDocuments();
      },
      deep: true,
    },
  },
  methods: {
    insertDocument() {
      this.documents.push(new CustomerOperationalDocumentModel());
      this.key = this.key + 1;
    },
    removeDocument(index) {
      if (this.documents.length > 1) {
        this.documents.splice(index, 1);
      }

      this.key = this.key + 1;
    },
    updateCustomerDocuments() {
      let documents = this.documents.filter((d) => d.document || d.id);
      this.customer.operationalDocuments = [ ...documents ];
      this.$emit("onChange", this.customer);
    },
  },
};
</script>

<style>

</style>